var map = {
	"./cloud.svg": 1580,
	"./cloudy.svg": 3440,
	"./day-clear.svg": 694,
	"./day-cloudy.svg": 4052,
	"./day-fog.svg": 1586,
	"./day-rain.svg": 5327,
	"./day-shower.svg": 8225,
	"./day-snow.svg": 5798,
	"./day-thunderstorm.svg": 6267,
	"./night-clear.svg": 6050,
	"./night-cloudy.svg": 9754,
	"./night-fog.svg": 2388,
	"./night-rain.svg": 2879,
	"./night-shower.svg": 2001,
	"./night-snow.svg": 4050,
	"./night-thunderstorm.svg": 5860,
	"./wi-barometer.svg": 3541,
	"./wi-humidity.svg": 6504,
	"./wi-sunrise.svg": 3281,
	"./wi-sunset.svg": 401,
	"./wi-wind-deg.svg": 8456,
	"./wi-windy.svg": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1644;